/**
 *
 * @param {Number} index
 * @param {HTML} element
 */
function MFRMap(index, element) {
  this.$element = $(element)

  this.selectors = {
    icons: ".map__icon",
    labels: ".map__label",
    map: ".map .image",
    accordion: ".accordion-item",
    busRoute: ".map__icon--bus-route",
    mapContainer: ".map__container"
  }

  this.init()
}

MFRMap.prototype = Object.assign({}, MFRMap.prototype, {
  init: function () {
    this.$icons = this.$element.find(this.selectors.icons)
    this.$labels = this.$element.find(this.selectors.labels)
    this.$map = this.$element.find(this.selectors.map)
    this.$mapContainer = this.$element.find(this.selectors.mapContainer)
    this.$accordion = this.$element.find(this.selectors.accordion)
    this.$busRoute = this.$element.find(this.selectors.busRoute)

    this.$accordion.on("click", this.__handleMapAccordionChange.bind(this))

    this.initActions()
    this.initMapAccordionState()
  },

  initActions: function () {
    const isFine = matchMedia("(pointer:fine)").matches

    if (isFine) {
      this.$labels.on("mouseenter", this.initFocus.bind(this)).on("mouseleave", this.initDefocus.bind(this))
    } else {
      this.$labels.on("click", this.initFocus.bind(this))
    }
  },

  initFocus: function (event) {
    const icon = this.$element.find(this.selectors.icons + "[data-for='" + $(event.currentTarget).attr("id") + "']")
    icon.addClass("is-active")

    this.$icons.removeClass("is-active")
    this.scrollToIcon(icon)
  },

  initDefocus: function (event) {
    const icon = this.$element.find(this.selectors.icons + "[data-for='" + $(event.currentTarget).attr("id") +"']")
    icon.removeClass("is-active")
  },

  scrollToIcon: function (element) {
    const leftPos = $(element).offset().left + element.width()
    this.$map.animate({ scrollLeft: "+=" + leftPos }, 500)
  },

  initMapAccordionState: function() {
    const $firstAccordion = this.$accordion.filter((index, item) => index === 0)

    if ( $firstAccordion.hasClass('is-active') ) {
      const index = $firstAccordion.data('index')
      $(`.map__icon[data-index="${index}"]`).addClass('is-show')
    }
  },

  __handleMapAccordionChange: function(event) {
    const $currentTarget = $(event.currentTarget)
    const activeindex = $currentTarget.data('index')
    const targetMap = $currentTarget.data('map')
    const busRouteIndex = this.$busRoute.data('index')
   
    if ($currentTarget.hasClass('is-active')) {
      $(`.map__icon[data-index="${activeindex}"]`).addClass('is-show')
    }

    $currentTarget.siblings().each(function() {
      const notActiveIndex = $(this).data('index')
      $(`.map__icon[data-index="${notActiveIndex}"]`).removeClass('is-show')
    })

    activeindex == busRouteIndex ? this.$busRoute.addClass('is-show') : this.$busRoute.removeClass('is-show')

    this.$mapContainer.children().each(function() {
      $(this).attr('id') === targetMap ? $(this).show() : $(this).hide()
    })
  }
})